(function () {
	Vue.component('nominow-left-navigation', {
		props: {
			items: {
				type: Array,
				required: true,
				default: () => []
			},
			showKey: {
				type: String,
				required: true
			},
			idKey: {
				type: String,
				required: false,
				default: '_id'
			},
			rootOnly: {
				type: Boolean,
				required: false,
				default: false
			},
			selectedtitle: {
				type: String
			},
			placeholder: {
				type: String,
				required: false,
				default: 'Search list'
			},
			placeholdersub: {
				type: String,
				required: false,
				default: 'Search list'
			},
			maxheight: {
				type: String,
				required: false,
				default: '80vh'
			},
			maxsubheight: {
				type: String,
				required: false,
				default: '70vh'
			}
		},
		data: function () {
			return {
				id: 'menu-' + new Date().getTime(),
				cssrootclass: 'js-list-menu-rootitem-' + new Date().getTime(),
				csssubclass: 'js-list-menu-subitem-' + new Date().getTime(),
				selectedRoot: null,
				selectedRootIndex: -1,
				selectedSub: null,
				filter: null,
				sessionKey: null
			};
		},
		template: `<div class="left-navigation" style="height:90vh;">
	<div v-if="!selectedRoot || rootOnly">
		<div>
			<div class="field control has-addons">
				<div class="control field ">
					<p class="control"><input name="search" :placeholder="placeholder" class="input" v-model="filter" type="text" v-on:keyup="filterRootList"></p>
				</div>

				<div class="control field dashboard-plus-icon">
					<a href="#" v-on:click.prevent="reloadData" class="button is-dark reload" title="reload Data"><span class="icon  is-small "><i
					aria-hidden="true" class="fa fa-refresh"></i></span></a>

					<a class="button is-dark" v-on:click.prevent="addNewRoot">
						<span class="icon has-text-centered  is-small  "><i aria-hidden="true" class="fa  fa-plus"></i></span>
					</a>
				</div>
			</div>
		</div>
		<ul class="menu-list" v-if="items != null && items.length > 0" style="overflow-x:hidden;overflow-y:auto;margin-bottom:1rem;" :style="'max-height: ' + maxheight + ';'">
			<li v-for="(elem, i) in items" :class="cssrootclass" class="left-nav-item">
				<a href="#" :class="{'is-active': selectedRoot != null && elem[idKey] == selectedRoot[idKey]}"
					v-on:click.prevent="selectRoot(elem, i)">
					<slot name="root-title" :elem="elem" :index="i">
						<span class="icon  is-small sub-item-dot" v-if="rootOnly">
							<i class="fa"  :class="{'fa-circle': selectedRoot != null && elem[idKey] == selectedRoot[idKey],'fa-circle-thin': selectedRoot == null || elem[idKey] != selectedRoot[idKey]}" aria-hidden="true"></i>
						</span>
						<span class="text">{{elem[showKey]}}</span>
						<span class="icon  is-small is-pulled-right" v-if="!rootOnly">
							<i class="fa  fa-caret-right" aria-hidden="true"></i>
						</span>
					</slot>
				</a>
			</li>
		</ul>
	</div>
	<div v-else>
		<div class="left-navigation">
			<div class="field control has-addons">
				<div class="control field dashboard-title">
					<p class="control">
						<span>{{selectedtitle || placeholder}}</span>
					</p>
				</div>
				<div class="control field dashboard-plus-icon">
					<a href="#" v-on:click.prevent="reloadData" class="button is-dark reload" title="reload Data"><span class="icon  is-small "><i
					aria-hidden="true" class="fa fa-refresh"></i></span></a>

					<a class="button is-dark" v-on:click.prevent="addNewRoot">
						<span class="icon has-text-centered  is-small  "><i aria-hidden="true" class="fa  fa-plus"></i></span>
					</a>
				</div>
			</div>
			<ul class="menu-list"><li>
				<a v-on:click.prevent="selectRoot(selectedRoot, selectedRootIndex)" :class="{'is-active': selectedSub == null}" href="#">
					<slot name="root-selected-title" :elem="selectedRoot">
					<span>{{selectedRoot[showKey]}}</span>
					</slot>
					<span class="icon  is-small is-pulled-right is-clickable" v-on:click.prevent="selectRoot(null, -1)">
						<i class="fa  fa-caret-left" aria-hidden="true"></i>
					</span>
				</a>
				</li>
			</ul>

			<div class="sub-items-container">
				<div class="field control has-addons sub-items">
					<div class="control field ">
						<p class="control"><input name="search" :placeholder="placeholdersub" class="input" v-model="filter" type="text" v-on:keyup="filterSubList"></p>
					</div>
					<div class="control field dashboard-plus-icon">
						<a class="button is-dark" v-on:click.prevent="addNewSub">
							<span class="icon has-text-centered  is-small  "><i aria-hidden="true" class="fa  fa-plus"></i></span>
						</a>
					</div>
				</div>

				<ul class="menu-list sub-items" v-if="selectedRoot.navSubItems != null && selectedRoot.navSubItems.length > 0" style="overflow-x:hidden;overflow-y:auto;margin-bottom:1rem;" :style="'max-height: ' + maxsubheight + ';'">
					<li v-for="(elem, i) in selectedRoot.navSubItems" :class="csssubclass">
						<slot name="sub-header" :elem="elem" :index="i" :all="selectedRoot.navSubItems"></slot>
						<a href="#" :class="{'is-active': selectedSub != null && elem['key'] == selectedSub['key']}"
							v-on:click.prevent="selectSub(elem, i)">
							<slot name="sub-title" :elem="elem" :index="i">
								<span class="icon  is-small sub-item-dot">
									<i class="fa"  :class="{'fa-circle': selectedSub != null && elem['key'] == selectedSub['key'],'fa-circle-thin': selectedSub == null || elem['key'] != selectedSub['key']}" aria-hidden="true"></i>
								</span>
								<span class="sub-item-dot-name">{{elem['name'] }}</span>
							</slot>
						</a>
					</li>
				</ul>
			</div>
		</div>


	</div>
</div>`,
		watch: {
			items: function (newVal, oldVal) {
				var self = this;
				const index = sessionStorage.getItem(this.sessionKey + "-root");

				if (this.items && index >= 0 && index < this.items.length) {
					console.log('select', index);
					const subindex = sessionStorage.getItem(self.sessionKey + "-sub");

					this.selectRoot(this.items[index], index, true);
					if (self.selectedRoot && self.selectedRoot.navSubItems && subindex < self.selectedRoot.navSubItems.length) {
						//console.log('select sub', subindex, self.selectedRoot.navSubItems.length);
						self.selectSub(self.selectedRoot.navSubItems[subindex], subindex);
					}
				} else if (this.items && this.items.length == 1) {
					console.log('select the one and only');
					//always select item if there is only one...
					self.selectRoot(this.items[0], 0, true);
				}
			}
		},
		created: function () {
			var self = this;
			this.sessionKey = 'nominow-left-navigation-' + document.location.pathname + '-' + this._uid;
			window.onpopstate = function (event) {
				console.log(
					`location: ${document.location}, state: ${JSON.stringify(
						event.state
					)}`
				);
				if (event && event.state && event.state.navItem == 'root') {
					var index = event.state.index;
					self.selectRoot(self.items[index], index);
				} else {
					// console.log('back!!!!!!!!!!!!');
					self.selectedRoot = null;
					self.selectedRootIndex = -1;
					self.selectedSub = null;
				}
			};

		},
		methods: {
			addNewRoot: function () {
				this.selectedRoot = null;
				this.selectedSub = null;
				sessionStorage.setItem(this.sessionKey + '-root', -1);
				sessionStorage.setItem(this.sessionKey + '-sub', -1);
				this.$emit('add-root');
			},
			addNewSub: function () {
				this.selectedSub = null;
				this.$emit('add-sub', this.selectedRoot);
			},
			selectRoot: function (elem, index, dontResetSub) {
				//console.log('selectRoot', elem, index, dontResetSub);
				this.selectedRoot = elem;
				this.selectedRootIndex = index;
				this.filter = null;
				this.$emit('select-root', elem, index);
				sessionStorage.setItem(this.sessionKey + '-root', index);

				if (!this.rootOnly) {
					history.pushState(
						{ navItem: 'root', selectedRootIndex: index },
						document.title,
						document.location.pathname
					);
				}
				if (!dontResetSub) {
					this.selectSub(null, -1);
				}
			},
			selectSub: function (elem, ix) {
				this.selectedSub = elem;
				this.$emit('select-sub', elem, ix);
				history.pushState(
					{ navItem: 'sub', selectedSubIndex: ix },
					document.title,
					document.location.pathname
				);
				sessionStorage.setItem(this.sessionKey + '-sub', ix);
			},
			reloadData: function () {
				//console.log('reload')
				this.$emit('reload-data');
			},
			filterRootList: function () {
				//console.log('filter', this.filter);
				const self = this;
				if (!self.filter || self.filter == '') {
					$('.' + this.cssrootclass).removeClass('is-hidden');
				} else {
					$('.' + this.cssrootclass).each(function () {
						const re = new RegExp(self.filter, 'gi');

						if (re.test($(this).text())) {
							$(this).removeClass('is-hidden');
						} else {
							$(this).addClass('is-hidden');
						}
					});
				}
			},
			filterSubList: function () {
				const self = this;
				if (!self.filter || self.filter == '') {
					$('.' + this.csssubclass).removeClass('is-hidden');
				} else {
					$('.' + this.csssubclass).each(function () {
						const re = new RegExp(self.filter, 'gi');

						if (re.test($(this).text())) {
							$(this).removeClass('is-hidden');
						} else {
							$(this).addClass('is-hidden');
						}
					});
				}
			}
		}
	});
})();
